module.exports = __webpack_public_path__ + "static/media/garage-car.cf558cbd.svg";